import { useRef } from 'react';
import type { SelectOption } from '../../property/types';

function deepEqualSelectOptions(options1: SelectOption[], options2: SelectOption[]): boolean {
  if (options1 === options2) return true;
  if (options1 == null || options2 == null) return options1 === options2;
  if (options1.length !== options2.length) return false;

  for (let index = 0; index < options1.length; index += 1) {
    const option1 = options1[index];
    const option2 = options2[index];

    if (option1.label !== option2.label
        || option1.value !== option2.value
        || option1.tag !== option2.tag
        || option1.disabled !== option2.disabled) {
      return false;
    }
  }

  return true;
}

export function useDeepCompareMemoize(value: SelectOption[]): number {
  const ref = useRef<SelectOption[]>([]);
  const signalRef = useRef<number>(0);

  if (!deepEqualSelectOptions(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  return signalRef.current;
}
